var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.632 12.105a1.296 1.296 0 0 1-.945.863c-.934.206-1.877.36-2.825.464a3.2 3.2 0 0 1-5.724 0 26.415 26.415 0 0 1-2.825-.464c-.446-.099-.8-.43-.945-.863a2.908 2.908 0 0 1 .703-2.976l.461-.462c.416-.415.59-1.019.462-1.593C2.282 3.868 4.716.8 8 .8c3.284 0 5.718 3.068 5.006 6.274a1.727 1.727 0 0 0 .461 1.593l.462.462a2.909 2.909 0 0 1 .703 2.976zM12.336 9.8l.462.461c.312.313.443.76.357 1.186-3.399.722-6.911.722-10.31 0a1.309 1.309 0 0 1 .357-1.186l.462-.461a3.327 3.327 0 0 0 .892-3.072C4.063 4.508 5.751 2.4 8 2.4c2.249 0 3.937 2.108 3.444 4.327a3.326 3.326 0 0 0 .892 3.072z",
  fill: "#F7F8F9"
});

function SvgNotificationOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOutline);
export default __webpack_public_path__ + "static/media/notification-outline.fd45f356.svg";
export { ForwardRef as ReactComponent };